// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * A simple summary of a planned activity suitable for a general care plan system (e.g. form driven) that doesn't know about specific resources such as procedure etc.
 */
export type ICarePlanActivityDetail = fhir.IBackboneElement & {
  /**
   * Tends to be less relevant for activities involving particular products.  Codes should not convey negation - use "prohibited" instead.
   */
  code?: fhir.ICodeableConcept|undefined;
  /**
   * Identifies the quantity expected to be consumed in a given day.
   */
  dailyAmount?: fhir.IQuantity|undefined;
  /**
   * This provides a textual description of constraints on the intended activity occurrence, including relation to other activities.  It may also include objectives, pre-conditions and end-conditions.  Finally, it may convey specifics about the activity such as body site, method, route, etc.
   */
  description?: string|undefined;
  _description?: fhir.IFhirElement|undefined;
  /**
   * This element is labeled as a modifier because it marks an activity as an activity that is not to be performed.
   */
  doNotPerform?: boolean|undefined;
  _doNotPerform?: fhir.IFhirElement|undefined;
  /**
   * Internal reference that identifies the goals that this activity is intended to contribute towards meeting.
   */
  goal?: fhir.IReference[]|undefined;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, questionnaire or other definition that is adhered to in whole or in part by this CarePlan activity.
   */
  instantiatesCanonical?: string[]|undefined;
  _instantiatesCanonical?: fhir.IFhirElement[]|undefined;
  /**
   * This might be an HTML page, PDF, etc. or could just be a non-resolvable URI identifier.
   */
  instantiatesUri?: string[]|undefined;
  _instantiatesUri?: fhir.IFhirElement[]|undefined;
  /**
   * A description of the kind of resource the in-line definition of a care plan activity is representing.  The CarePlan.activity.detail is an in-line definition when a resource is not referenced using CarePlan.activity.reference.  For example, a MedicationRequest, a ServiceRequest, or a CommunicationRequest.
   */
  kind?: CarePlanActivityDetailKindEnum|undefined;
  _kind?: fhir.IFhirElement|undefined;
  /**
   * May reference a specific clinical location or may identify a type of location.
   */
  location?: fhir.IReference|undefined;
  /**
   * A performer MAY also be a participant in the care plan.
   */
  performer?: fhir.IReference[]|undefined;
  /**
   * Identifies the food, drug or other product to be consumed or supplied in the activity.
   */
  productCodeableConcept?: fhir.ICodeableConcept|undefined;
  /**
   * Identifies the food, drug or other product to be consumed or supplied in the activity.
   */
  productReference?: fhir.IReference|undefined;
  /**
   * Identifies the quantity expected to be supplied, administered or consumed by the subject.
   */
  quantity?: fhir.IQuantity|undefined;
  /**
   * This could be a diagnosis code.  If a full condition record exists or additional detail is needed, use reasonCondition instead.
   */
  reasonCode?: fhir.ICodeableConcept[]|undefined;
  /**
   * Conditions can be identified at the activity level that are not identified as reasons for the overall plan.
   */
  reasonReference?: fhir.IReference[]|undefined;
  /**
   * The period, timing or frequency upon which the described activity is to occur.
   */
  scheduledTiming?: fhir.ITiming|undefined;
  /**
   * The period, timing or frequency upon which the described activity is to occur.
   */
  scheduledPeriod?: fhir.IPeriod|undefined;
  /**
   * The period, timing or frequency upon which the described activity is to occur.
   */
  scheduledString?: string|undefined;
  _scheduledString?: fhir.IFhirElement|undefined;
  /**
   * Some aspects of status can be inferred based on the resources linked in actionTaken.  Note that "status" is only as current as the plan was most recently updated.  
   * The unknown code is not to be used to convey other statuses.  The unknown code should be used when one of the statuses applies, but the authoring system doesn't know the current state of the activity.
   */
  status: CarePlanActivityDetailStatusEnum|null;
  _status?: fhir.IFhirElement|undefined;
  /**
   * Will generally not be present if status is "complete".  Be sure to prompt to update this (or at least remove the existing value) if the status is changed.
   */
  statusReason?: fhir.ICodeableConcept|undefined;
}
/**
 * Identifies a planned action to occur as part of the plan.  For example, a medication to be used, lab tests to perform, self-monitoring, education, etc.
 */
export type ICarePlanActivity = fhir.IBackboneElement & {
  /**
   * A simple summary of a planned activity suitable for a general care plan system (e.g. form driven) that doesn't know about specific resources such as procedure etc.
   */
  detail?: fhir.ICarePlanActivityDetail|undefined;
  /**
   * Note that this should not duplicate the activity status (e.g. completed or in progress).
   */
  outcomeCodeableConcept?: fhir.ICodeableConcept[]|undefined;
  /**
   * The activity outcome is independent of the outcome of the related goal(s).  For example, if the goal is to achieve a target body weight of 150 lbs and an activity is defined to diet, then the activity outcome could be calories consumed whereas the goal outcome is an observation for the actual body weight measured.
   */
  outcomeReference?: fhir.IReference[]|undefined;
  /**
   * This element should NOT be used to describe the activity to be performed - that occurs either within the resource pointed to by activity.detail.reference or in activity.detail.description.
   */
  progress?: fhir.IAnnotation[]|undefined;
  /**
   * Standard extension exists ([resource-pertainsToGoal](extension-resource-pertainstogoal.html)) that allows goals to be referenced from any of the referenced resources in CarePlan.activity.reference.  
   * The goal should be visible when the resource referenced by CarePlan.activity.reference is viewed independently from the CarePlan.  Requests that are pointed to by a CarePlan using this element should *not* point to this CarePlan using the "basedOn" element.  i.e. Requests that are part of a CarePlan are not "based on" the CarePlan.
   */
  reference?: fhir.IReference|undefined;
}
/**
 * Describes the intention of how one or more practitioners intend to deliver care for a particular patient, group or community for a period of time, possibly limited to care for a specific condition or set of conditions.
 */
export type ICarePlan = fhir.IDomainResource & {
  /**
   * Resource Type Name
   */
  resourceType: "CarePlan";
  /**
   * Identifies a planned action to occur as part of the plan.  For example, a medication to be used, lab tests to perform, self-monitoring, education, etc.
   */
  activity?: fhir.ICarePlanActivity[]|undefined;
  /**
   * When the diagnosis is related to an allergy or intolerance, the Condition and AllergyIntolerance resources can both be used. However, to be actionable for decision support, using Condition alone is not sufficient as the allergy or intolerance condition needs to be represented as an AllergyIntolerance.
   */
  addresses?: fhir.IReference[]|undefined;
  /**
   * The author may also be a contributor.  For example, an organization can be an author, but not listed as a contributor.
   */
  author?: fhir.IReference|undefined;
  /**
   * A care plan that is fulfilled in whole or in part by this care plan.
   */
  basedOn?: fhir.IReference[]|undefined;
  /**
   * Identifies all people and organizations who are expected to be involved in the care envisioned by this plan.
   */
  careTeam?: fhir.IReference[]|undefined;
  /**
   * There may be multiple axes of categorization and one plan may serve multiple purposes.  In some cases, this may be redundant with references to CarePlan.concern.
   */
  category?: fhir.ICodeableConcept[]|undefined;
  /**
   * Collaborative care plans may have multiple contributors.
   */
  contributor?: fhir.IReference[]|undefined;
  /**
   * Represents when this particular CarePlan record was created in the system, which is often a system-generated date.
   */
  created?: string|undefined;
  _created?: fhir.IFhirElement|undefined;
  /**
   * A description of the scope and nature of the plan.
   */
  description?: string|undefined;
  _description?: fhir.IFhirElement|undefined;
  /**
   * This will typically be the encounter the event occurred within, but some activities may be initiated prior to or after the official completion of an encounter but still be tied to the context of the encounter. CarePlan activities conducted as a result of the care plan may well occur as part of other encounters.
   */
  encounter?: fhir.IReference|undefined;
  /**
   * Goal can be achieving a particular change or merely maintaining a current state or even slowing a decline.
   */
  goal?: fhir.IReference[]|undefined;
  /**
   * This is a business identifier, not a resource identifier (see [discussion](resource.html#identifiers)).  It is best practice for the identifier to only appear on a single resource instance, however business practices may occasionally dictate that multiple resource instances with the same identifier can exist - possibly even with different resource types.  For example, multiple Patient and a Person resource instance might share the same social insurance number.
   */
  identifier?: fhir.IIdentifier[]|undefined;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, questionnaire or other definition that is adhered to in whole or in part by this CarePlan.
   */
  instantiatesCanonical?: string[]|undefined;
  _instantiatesCanonical?: fhir.IFhirElement[]|undefined;
  /**
   * This might be an HTML page, PDF, etc. or could just be a non-resolvable URI identifier.
   */
  instantiatesUri?: string[]|undefined;
  _instantiatesUri?: fhir.IFhirElement[]|undefined;
  /**
   * This element is labeled as a modifier because the intent alters when and how the resource is actually applicable.
   */
  intent: CarePlanIntentEnum|null;
  _intent?: fhir.IFhirElement|undefined;
  /**
   * General notes about the care plan not covered elsewhere.
   */
  note?: fhir.IAnnotation[]|undefined;
  /**
   * Each care plan is an independent request, such that having a care plan be part of another care plan can cause issues with cascading statuses.  As such, this element is still being discussed.
   */
  partOf?: fhir.IReference[]|undefined;
  /**
   * Any activities scheduled as part of the plan should be constrained to the specified period regardless of whether the activities are planned within a single encounter/episode or across multiple encounters/episodes (e.g. the longitudinal management of a chronic condition).
   */
  period?: fhir.IPeriod|undefined;
  /**
   * The replacement could be because the initial care plan was immediately rejected (due to an issue) or because the previous care plan was completed, but the need for the action described by the care plan remains ongoing.
   */
  replaces?: fhir.IReference[]|undefined;
  /**
   * The unknown code is not to be used to convey other statuses.  The unknown code should be used when one of the statuses applies, but the authoring system doesn't know the current state of the care plan.
   * This element is labeled as a modifier because the status contains the code entered-in-error that marks the plan as not currently valid.
   */
  status: CarePlanStatusEnum|null;
  _status?: fhir.IFhirElement|undefined;
  /**
   * Identifies the patient or group whose intended care is described by the plan.
   */
  subject: fhir.IReference|null;
  /**
   * Use "concern" to identify specific conditions addressed by the care plan.
   */
  supportingInfo?: fhir.IReference[]|undefined;
  /**
   * Human-friendly name for the care plan.
   */
  title?: string|undefined;
  _title?: fhir.IFhirElement|undefined;
}
/**
 * A simple summary of a planned activity suitable for a general care plan system (e.g. form driven) that doesn't know about specific resources such as procedure etc.
 */
export class CarePlanActivityDetail extends fhir.BackboneElement implements fhir.ICarePlanActivityDetail {
  /**
   * Tends to be less relevant for activities involving particular products.  Codes should not convey negation - use "prohibited" instead.
   */
  public code?: fhir.CodeableConcept|undefined;
  /**
   * Identifies the quantity expected to be consumed in a given day.
   */
  public dailyAmount?: fhir.Quantity|undefined;
  /**
   * This provides a textual description of constraints on the intended activity occurrence, including relation to other activities.  It may also include objectives, pre-conditions and end-conditions.  Finally, it may convey specifics about the activity such as body site, method, route, etc.
   */
  public description?: string|undefined;
  public _description?: fhir.FhirElement|undefined;
  /**
   * This element is labeled as a modifier because it marks an activity as an activity that is not to be performed.
   */
  public doNotPerform?: boolean|undefined;
  public _doNotPerform?: fhir.FhirElement|undefined;
  /**
   * Internal reference that identifies the goals that this activity is intended to contribute towards meeting.
   */
  public goal?: fhir.Reference[]|undefined;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, questionnaire or other definition that is adhered to in whole or in part by this CarePlan activity.
   */
  public instantiatesCanonical?: string[]|undefined;
  public _instantiatesCanonical?: fhir.FhirElement[]|undefined;
  /**
   * This might be an HTML page, PDF, etc. or could just be a non-resolvable URI identifier.
   */
  public instantiatesUri?: string[]|undefined;
  public _instantiatesUri?: fhir.FhirElement[]|undefined;
  /**
   * A description of the kind of resource the in-line definition of a care plan activity is representing.  The CarePlan.activity.detail is an in-line definition when a resource is not referenced using CarePlan.activity.reference.  For example, a MedicationRequest, a ServiceRequest, or a CommunicationRequest.
   */
  public kind?: CarePlanActivityDetailKindEnum|undefined;
  public _kind?: fhir.FhirElement|undefined;
  /**
   * May reference a specific clinical location or may identify a type of location.
   */
  public location?: fhir.Reference|undefined;
  /**
   * A performer MAY also be a participant in the care plan.
   */
  public performer?: fhir.Reference[]|undefined;
  /**
   * Identifies the food, drug or other product to be consumed or supplied in the activity.
   */
  public productCodeableConcept?: fhir.CodeableConcept|undefined;
  /**
   * Identifies the food, drug or other product to be consumed or supplied in the activity.
   */
  public productReference?: fhir.Reference|undefined;
  /**
   * Identifies the quantity expected to be supplied, administered or consumed by the subject.
   */
  public quantity?: fhir.Quantity|undefined;
  /**
   * This could be a diagnosis code.  If a full condition record exists or additional detail is needed, use reasonCondition instead.
   */
  public reasonCode?: fhir.CodeableConcept[]|undefined;
  /**
   * Conditions can be identified at the activity level that are not identified as reasons for the overall plan.
   */
  public reasonReference?: fhir.Reference[]|undefined;
  /**
   * The period, timing or frequency upon which the described activity is to occur.
   */
  public scheduledTiming?: fhir.Timing|undefined;
  /**
   * The period, timing or frequency upon which the described activity is to occur.
   */
  public scheduledPeriod?: fhir.Period|undefined;
  /**
   * The period, timing or frequency upon which the described activity is to occur.
   */
  public scheduledString?: string|undefined;
  public _scheduledString?: fhir.FhirElement|undefined;
  /**
   * Some aspects of status can be inferred based on the resources linked in actionTaken.  Note that "status" is only as current as the plan was most recently updated.  
   * The unknown code is not to be used to convey other statuses.  The unknown code should be used when one of the statuses applies, but the authoring system doesn't know the current state of the activity.
   */
  public status: CarePlanActivityDetailStatusEnum|null;
  public _status?: fhir.FhirElement|undefined;
  /**
   * Will generally not be present if status is "complete".  Be sure to prompt to update this (or at least remove the existing value) if the status is changed.
   */
  public statusReason?: fhir.CodeableConcept|undefined;
  /**
   * Default constructor for CarePlanActivityDetail - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.ICarePlanActivityDetail> = {}) {
    super(source);
    if (source["code"]) { this.code = new fhir.CodeableConcept(source.code!); }
    if (source["dailyAmount"]) { this.dailyAmount = new fhir.Quantity(source.dailyAmount!); }
    if (source["description"]) { this.description = source.description; }
    if (source["_description"]) { this._description = new fhir.FhirElement(source._description!); }
    if (source["doNotPerform"]) { this.doNotPerform = source.doNotPerform; }
    if (source["_doNotPerform"]) { this._doNotPerform = new fhir.FhirElement(source._doNotPerform!); }
    if (source["goal"]) { this.goal = source.goal.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["instantiatesCanonical"]) { this.instantiatesCanonical = source.instantiatesCanonical.map((x) => (x)); }
    if (source["_instantiatesCanonical"]) { this._instantiatesCanonical = source._instantiatesCanonical.map((x:Partial<fhir.IFhirElement>) => new fhir.FhirElement(x)); }
    if (source["instantiatesUri"]) { this.instantiatesUri = source.instantiatesUri.map((x) => (x)); }
    if (source["_instantiatesUri"]) { this._instantiatesUri = source._instantiatesUri.map((x:Partial<fhir.IFhirElement>) => new fhir.FhirElement(x)); }
    if (source["kind"]) { this.kind = source.kind; }
    if (source["_kind"]) { this._kind = new fhir.FhirElement(source._kind!); }
    if (source["location"]) { this.location = new fhir.Reference(source.location!); }
    if (source["performer"]) { this.performer = source.performer.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["productCodeableConcept"]) { this.productCodeableConcept = new fhir.CodeableConcept(source.productCodeableConcept!); }
    if (source["productReference"]) { this.productReference = new fhir.Reference(source.productReference!); }
    if (source["quantity"]) { this.quantity = new fhir.Quantity(source.quantity!); }
    if (source["reasonCode"]) { this.reasonCode = source.reasonCode.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
    if (source["reasonReference"]) { this.reasonReference = source.reasonReference.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["scheduledTiming"]) { this.scheduledTiming = new fhir.Timing(source.scheduledTiming!); }
    if (source["scheduledPeriod"]) { this.scheduledPeriod = new fhir.Period(source.scheduledPeriod!); }
    if (source["scheduledString"]) { this.scheduledString = source.scheduledString; }
    if (source["_scheduledString"]) { this._scheduledString = new fhir.FhirElement(source._scheduledString!); }
    this.status = null;
    if (source["status"]) { this.status = source.status; }
    if (this.status === undefined) { this.status = null }
    if (source["_status"]) { this._status = new fhir.FhirElement(source._status!); }
    if (source["statusReason"]) { this.statusReason = new fhir.CodeableConcept(source.statusReason!); }
  }
  /**
   * Check if the current CarePlanActivityDetail contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    if (this["status"] === undefined) { missingElements.push("status"); }
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a CarePlanActivityDetail from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.ICarePlanActivityDetail):CarePlanActivityDetail {
    var dest:CarePlanActivityDetail = new CarePlanActivityDetail(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `CarePlanActivityDetail is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * Identifies a planned action to occur as part of the plan.  For example, a medication to be used, lab tests to perform, self-monitoring, education, etc.
 */
export class CarePlanActivity extends fhir.BackboneElement implements fhir.ICarePlanActivity {
  /**
   * A simple summary of a planned activity suitable for a general care plan system (e.g. form driven) that doesn't know about specific resources such as procedure etc.
   */
  public detail?: fhir.CarePlanActivityDetail|undefined;
  /**
   * Note that this should not duplicate the activity status (e.g. completed or in progress).
   */
  public outcomeCodeableConcept?: fhir.CodeableConcept[]|undefined;
  /**
   * The activity outcome is independent of the outcome of the related goal(s).  For example, if the goal is to achieve a target body weight of 150 lbs and an activity is defined to diet, then the activity outcome could be calories consumed whereas the goal outcome is an observation for the actual body weight measured.
   */
  public outcomeReference?: fhir.Reference[]|undefined;
  /**
   * This element should NOT be used to describe the activity to be performed - that occurs either within the resource pointed to by activity.detail.reference or in activity.detail.description.
   */
  public progress?: fhir.Annotation[]|undefined;
  /**
   * Standard extension exists ([resource-pertainsToGoal](extension-resource-pertainstogoal.html)) that allows goals to be referenced from any of the referenced resources in CarePlan.activity.reference.  
   * The goal should be visible when the resource referenced by CarePlan.activity.reference is viewed independently from the CarePlan.  Requests that are pointed to by a CarePlan using this element should *not* point to this CarePlan using the "basedOn" element.  i.e. Requests that are part of a CarePlan are not "based on" the CarePlan.
   */
  public reference?: fhir.Reference|undefined;
  /**
   * Default constructor for CarePlanActivity - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.ICarePlanActivity> = {}) {
    super(source);
    if (source["detail"]) { this.detail = new fhir.CarePlanActivityDetail(source.detail!); }
    if (source["outcomeCodeableConcept"]) { this.outcomeCodeableConcept = source.outcomeCodeableConcept.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
    if (source["outcomeReference"]) { this.outcomeReference = source.outcomeReference.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["progress"]) { this.progress = source.progress.map((x:Partial<fhir.IAnnotation>) => new fhir.Annotation(x)); }
    if (source["reference"]) { this.reference = new fhir.Reference(source.reference!); }
  }
  /**
   * Check if the current CarePlanActivity contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a CarePlanActivity from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.ICarePlanActivity):CarePlanActivity {
    var dest:CarePlanActivity = new CarePlanActivity(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `CarePlanActivity is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * Describes the intention of how one or more practitioners intend to deliver care for a particular patient, group or community for a period of time, possibly limited to care for a specific condition or set of conditions.
 */
export class CarePlan extends fhir.DomainResource implements fhir.ICarePlan {
  /**
   * Resource Type Name
   */
  public override resourceType: "CarePlan";
  /**
   * Identifies a planned action to occur as part of the plan.  For example, a medication to be used, lab tests to perform, self-monitoring, education, etc.
   */
  public activity?: fhir.CarePlanActivity[]|undefined;
  /**
   * When the diagnosis is related to an allergy or intolerance, the Condition and AllergyIntolerance resources can both be used. However, to be actionable for decision support, using Condition alone is not sufficient as the allergy or intolerance condition needs to be represented as an AllergyIntolerance.
   */
  public addresses?: fhir.Reference[]|undefined;
  /**
   * The author may also be a contributor.  For example, an organization can be an author, but not listed as a contributor.
   */
  public author?: fhir.Reference|undefined;
  /**
   * A care plan that is fulfilled in whole or in part by this care plan.
   */
  public basedOn?: fhir.Reference[]|undefined;
  /**
   * Identifies all people and organizations who are expected to be involved in the care envisioned by this plan.
   */
  public careTeam?: fhir.Reference[]|undefined;
  /**
   * There may be multiple axes of categorization and one plan may serve multiple purposes.  In some cases, this may be redundant with references to CarePlan.concern.
   */
  public category?: fhir.CodeableConcept[]|undefined;
  /**
   * Collaborative care plans may have multiple contributors.
   */
  public contributor?: fhir.Reference[]|undefined;
  /**
   * Represents when this particular CarePlan record was created in the system, which is often a system-generated date.
   */
  public created?: string|undefined;
  public _created?: fhir.FhirElement|undefined;
  /**
   * A description of the scope and nature of the plan.
   */
  public description?: string|undefined;
  public _description?: fhir.FhirElement|undefined;
  /**
   * This will typically be the encounter the event occurred within, but some activities may be initiated prior to or after the official completion of an encounter but still be tied to the context of the encounter. CarePlan activities conducted as a result of the care plan may well occur as part of other encounters.
   */
  public encounter?: fhir.Reference|undefined;
  /**
   * Goal can be achieving a particular change or merely maintaining a current state or even slowing a decline.
   */
  public goal?: fhir.Reference[]|undefined;
  /**
   * This is a business identifier, not a resource identifier (see [discussion](resource.html#identifiers)).  It is best practice for the identifier to only appear on a single resource instance, however business practices may occasionally dictate that multiple resource instances with the same identifier can exist - possibly even with different resource types.  For example, multiple Patient and a Person resource instance might share the same social insurance number.
   */
  public identifier?: fhir.Identifier[]|undefined;
  /**
   * The URL pointing to a FHIR-defined protocol, guideline, questionnaire or other definition that is adhered to in whole or in part by this CarePlan.
   */
  public instantiatesCanonical?: string[]|undefined;
  public _instantiatesCanonical?: fhir.FhirElement[]|undefined;
  /**
   * This might be an HTML page, PDF, etc. or could just be a non-resolvable URI identifier.
   */
  public instantiatesUri?: string[]|undefined;
  public _instantiatesUri?: fhir.FhirElement[]|undefined;
  /**
   * This element is labeled as a modifier because the intent alters when and how the resource is actually applicable.
   */
  public intent: CarePlanIntentEnum|null;
  public _intent?: fhir.FhirElement|undefined;
  /**
   * General notes about the care plan not covered elsewhere.
   */
  public note?: fhir.Annotation[]|undefined;
  /**
   * Each care plan is an independent request, such that having a care plan be part of another care plan can cause issues with cascading statuses.  As such, this element is still being discussed.
   */
  public partOf?: fhir.Reference[]|undefined;
  /**
   * Any activities scheduled as part of the plan should be constrained to the specified period regardless of whether the activities are planned within a single encounter/episode or across multiple encounters/episodes (e.g. the longitudinal management of a chronic condition).
   */
  public period?: fhir.Period|undefined;
  /**
   * The replacement could be because the initial care plan was immediately rejected (due to an issue) or because the previous care plan was completed, but the need for the action described by the care plan remains ongoing.
   */
  public replaces?: fhir.Reference[]|undefined;
  /**
   * The unknown code is not to be used to convey other statuses.  The unknown code should be used when one of the statuses applies, but the authoring system doesn't know the current state of the care plan.
   * This element is labeled as a modifier because the status contains the code entered-in-error that marks the plan as not currently valid.
   */
  public status: CarePlanStatusEnum|null;
  public _status?: fhir.FhirElement|undefined;
  /**
   * Identifies the patient or group whose intended care is described by the plan.
   */
  public subject: fhir.Reference|null;
  /**
   * Use "concern" to identify specific conditions addressed by the care plan.
   */
  public supportingInfo?: fhir.Reference[]|undefined;
  /**
   * Human-friendly name for the care plan.
   */
  public title?: string|undefined;
  public _title?: fhir.FhirElement|undefined;
  /**
   * Default constructor for CarePlan - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.ICarePlan> = {}) {
    super(source);
    this.resourceType = 'CarePlan';
    if (source["activity"]) { this.activity = source.activity.map((x:Partial<fhir.ICarePlanActivity>) => new fhir.CarePlanActivity(x)); }
    if (source["addresses"]) { this.addresses = source.addresses.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["author"]) { this.author = new fhir.Reference(source.author!); }
    if (source["basedOn"]) { this.basedOn = source.basedOn.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["careTeam"]) { this.careTeam = source.careTeam.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["category"]) { this.category = source.category.map((x:Partial<fhir.ICodeableConcept>) => new fhir.CodeableConcept(x)); }
    if (source["contributor"]) { this.contributor = source.contributor.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["created"]) { this.created = source.created; }
    if (source["_created"]) { this._created = new fhir.FhirElement(source._created!); }
    if (source["description"]) { this.description = source.description; }
    if (source["_description"]) { this._description = new fhir.FhirElement(source._description!); }
    if (source["encounter"]) { this.encounter = new fhir.Reference(source.encounter!); }
    if (source["goal"]) { this.goal = source.goal.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["identifier"]) { this.identifier = source.identifier.map((x:Partial<fhir.IIdentifier>) => new fhir.Identifier(x)); }
    if (source["instantiatesCanonical"]) { this.instantiatesCanonical = source.instantiatesCanonical.map((x) => (x)); }
    if (source["_instantiatesCanonical"]) { this._instantiatesCanonical = source._instantiatesCanonical.map((x:Partial<fhir.IFhirElement>) => new fhir.FhirElement(x)); }
    if (source["instantiatesUri"]) { this.instantiatesUri = source.instantiatesUri.map((x) => (x)); }
    if (source["_instantiatesUri"]) { this._instantiatesUri = source._instantiatesUri.map((x:Partial<fhir.IFhirElement>) => new fhir.FhirElement(x)); }
    this.intent = null;
    if (source["intent"]) { this.intent = source.intent; }
    if (this.intent === undefined) { this.intent = null }
    if (source["_intent"]) { this._intent = new fhir.FhirElement(source._intent!); }
    if (source["note"]) { this.note = source.note.map((x:Partial<fhir.IAnnotation>) => new fhir.Annotation(x)); }
    if (source["partOf"]) { this.partOf = source.partOf.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["period"]) { this.period = new fhir.Period(source.period!); }
    if (source["replaces"]) { this.replaces = source.replaces.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    this.status = null;
    if (source["status"]) { this.status = source.status; }
    if (this.status === undefined) { this.status = null }
    if (source["_status"]) { this._status = new fhir.FhirElement(source._status!); }
    this.subject = null;
    if (source["subject"]) { this.subject = new fhir.Reference(source.subject!); }
    if (this.subject === undefined) { this.subject = null }
    if (source["supportingInfo"]) { this.supportingInfo = source.supportingInfo.map((x:Partial<fhir.IReference>) => new fhir.Reference(x)); }
    if (source["title"]) { this.title = source.title; }
    if (source["_title"]) { this._title = new fhir.FhirElement(source._title!); }
  }
  /**
   * Check if the current CarePlan contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    if (this["intent"] === undefined) { missingElements.push("intent"); }
    if (this["status"] === undefined) { missingElements.push("status"); }
    if (this["subject"] === undefined) { missingElements.push("subject"); }
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a CarePlan from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.ICarePlan):CarePlan {
    var dest:CarePlan = new CarePlan(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `CarePlan is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
/**
 * Code Values for the CarePlan.activity.detail.kind field
 */
export enum CarePlanActivityDetailKindEnum {
  APPOINTMENT = "Appointment",
  COMMUNICATIONREQUEST = "CommunicationRequest",
  DEVICEREQUEST = "DeviceRequest",
  MEDICATIONREQUEST = "MedicationRequest",
  NUTRITIONORDER = "NutritionOrder",
  TASK = "Task",
  SERVICEREQUEST = "ServiceRequest",
  VISIONPRESCRIPTION = "VisionPrescription",
}
/**
 * Code Values for the CarePlan.activity.detail.status field
 */
export enum CarePlanActivityDetailStatusEnum {
  NOT_STARTED = "not-started",
  SCHEDULED = "scheduled",
  IN_PROGRESS = "in-progress",
  ON_HOLD = "on-hold",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  STOPPED = "stopped",
  UNKNOWN = "unknown",
  ENTERED_IN_ERROR = "entered-in-error",
}
/**
 * Code Values for the CarePlan.intent field
 */
export enum CarePlanIntentEnum {
  PROPOSAL = "proposal",
  PLAN = "plan",
  ORDER = "order",
  OPTION = "option",
}
/**
 * Code Values for the CarePlan.status field
 */
export enum CarePlanStatusEnum {
  DRAFT = "draft",
  ACTIVE = "active",
  ON_HOLD = "on-hold",
  REVOKED = "revoked",
  COMPLETED = "completed",
  ENTERED_IN_ERROR = "entered-in-error",
  UNKNOWN = "unknown",
}
